import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

//Components
import Layout from "../../../Layout/Layout";
import Constants from "../../../common/SupplierConstants";
import { SearchField } from "../../../Components/formElements/SearchField";
import StatusCountForList from "../../../Components/StatusCountForList";
import { TableStatusField } from "../../../Components/formElements/TableStatusField";
import ShowStatus from "../../../Components/Modal/supplier_app/Workflow/ShowStatus";
import { formatDateTime } from "../../../common/Validations";
import {
  getPQVendorList,
  setPQQuery,
  addPQVendorId,
  addPQSubmissionRef,
  resetPQWorkflow,
} from "../../../redux/feature/supplier_app/pqVendorSlice";

const PQVendorList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  localStorage.setItem("menu", "PQ Vendor");
  localStorage.setItem("submenu", "PQ Vendor List");

  const pqList = useSelector((state) => state?.pqVendor?.pqList);
  const pqQuery = pqList?.query || {};
  const pqPagination = pqList?.pagination || { page: 1, per_page: 10, total: 0 };

  const [isCardVisible, setCardVisible] = useState(true);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState(
    pqQuery.searchTerm || ""
  );

  const [modalShowStatus, setModalShowStatus] = useState(false);
  const [sendDataModal, setSendDataModal] = useState("");
  const [modelTitle, setModelTitle] = useState("");

  const showStatusInfo = (rowData) => {
    setModalShowStatus(true);
    setSendDataModal(rowData);
    setModelTitle("Status Information");
  };

  const hideModalStatus = () => {
    setModalShowStatus(false);
  };

  const statusCountData = (pqList?.statusCounts || []).map((row) => ({
    id: row._id || row.name,
    name: row._id || row.name || "--",
    count: row.count || 0,
  }));

  useEffect(() => {
    dispatch(
      getPQVendorList({
        page: 1,
        per_page: pqQuery.per_page || 10,
        searchTerm: "",
        sortField: "createdAt",
        sortDirection: "desc",
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageChange = (nextPage) => {
    dispatch(
      getPQVendorList({
        ...pqQuery,
        page: nextPage,
        searchTerm: getCommonSearchTxt,
      })
    );
  };

  const handlePerRowsChange = async (newPerPage, nextPage) => {
    dispatch(
      getPQVendorList({
        ...pqQuery,
        page: nextPage,
        per_page: newPerPage,
        searchTerm: getCommonSearchTxt,
      })
    );
  };

  const handleSearchFuncApi = () => {
    dispatch(setPQQuery({ searchTerm: getCommonSearchTxt }));
    dispatch(
      getPQVendorList({
        ...pqQuery,
        page: 1,
        searchTerm: getCommonSearchTxt,
      })
    );
  };

  const openSubmissionDetails = (row) => {
    dispatch(
      addPQSubmissionRef({
        referenceNumber: row.referenceNumber || "",
        email: row.email !== "--" ? row.email : "",
      })
    );
    dispatch(addPQVendorId(row.pqVendorId || ""));
    navigate(Constants.PQ_SUBMISSION_DETAILS);
  };

  const openVendorDetails = (row) => {
    dispatch(addPQVendorId(row.pqVendorId || ""));
    navigate(Constants.PQ_VENDOR_DETAILS);
  };

  const openWorkflowDetails = (row) => {
    dispatch(addPQVendorId(row.pqVendorId || ""));
    dispatch(resetPQWorkflow());
    navigate(Constants.PQ_VENDOR_WORKFLOW);
  };

  const inviteSupplier = () => {
    navigate(Constants.VENDOR_INVITE_SUPPLIER);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  const columns = [
    {
      name: "Profile",
      width: "80px",
      cell: () => (
        <img
          src="assets/img/profile-img.png"
          alt="Profile"
          className="rounded-circle profileImageCss"
          style={{ width: "40px" }}
        />
      ),
    },
    {
      name: "PQ Vendor ID",
      selector: (row) => row.pqVendorId || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btnInfo"
          title={row.pqVendorId || ""}
          onClick={() => openVendorDetails(row)}
        >
          {row.pqVendorId || "-"}
        </button>
      ),
      width: "130px",
    },
    // {
    //   name: "Supplier ID",
    //   selector: (row) => row.supplierId || "--",
    //   sortable: true,
    //   width: "120px",
    // },
    {
      name: "Company Name",
      cell: (row) => (
        <span className="m-0 p-0 pt-1 fw-bold">
          {row.organisationName || row.companyName || "--"}
        </span>
      ),
      selector: (row) => row.organisationName || row.companyName,
      sortable: true,
      width: "180px",
    },
    {
      name: "Email",
      selector: (row) => row.email || "--",
      sortable: true,
      width: "220px",
    },
    {
      name: "Category",
      selector: (row) => row.category || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Sub Category",
      selector: (row) => row.subCategory || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Template",
      selector: (row) => row.template || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Reference No",
      selector: (row) => row.referenceNumber || "--",
      sortable: true,
      cell: (row) =>
        row.referenceNumber ? (
          <button
            className="btnInfo"
            title="Open submission details"
            onClick={() => openSubmissionDetails(row)}
          >
            {row.referenceNumber}
          </button>
        ) : (
          <span>--</span>
        ),
      width: "150px",
    },
    {
      name: "Workflow log",
      selector: (row) => row.workflowActionLogs,
      cell: (row) => (
        <div
          style={{ width: "100%" }}
          className="d-flex justify-content-center iconTable"
        >
          <img
            src="assets/img/newIcons/workflow.png"
            alt="attachments"
            style={{ width: "35px" }}
            className="mt-1"
            onClick={() => showStatusInfo(row.workflowActionLogs)}
          />
        </div>
      ),
      sortable: true,
      width: "132px",
    },
    {
      name: "Source",
      selector: (row) => row.sourceType || "--",
      sortable: true,
      width: "110px",
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => <TableStatusField status={row.status} />,
      width: "150px",
    },
    {
      name: "Created Date",
      selector: (row) => formatDateTime(row.createdAt),
      sortable: true,
      width: "160px",
    },
    {
      name: "Actions",
      width: "240px",
      cell: (row) => (
        <div className="d-flex gap-2">
          <button
            className="btnTable text-nowrap"
            onClick={() => openSubmissionDetails(row)}
            title="View submission / invitation details"
          >
            <i className="bi bi-eye"></i> Details
          </button>
          {(row.workflowActionLogs || []).length > 0 && (
            <button
              className="btnTable text-nowrap"
              onClick={() => openWorkflowDetails(row)}
              title="Open workflow details / approve"
            >
              <i className="bi bi-diagram-3"></i> Workflow
            </button>
          )}
        </div>
      ),
    },
  ];

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">PQ Vendor List</h2>
                <p className="subText">
                  Pre-Qualification vendor directory (separate from Vendor List)
                </p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
            </Row>
            <hr />

            {statusCountData.length > 0 && (
              <StatusCountForList statuscountdata={statusCountData} />
            )}

            <div className="accordion" id="pqVendorAccordion">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PQ</span>
                    </Col>
                    <Col xs={8} md={2} lg={2}>
                      <span className="headerTitle">PQ Vendor List</span>
                      <span className="subHeaderTitle">
                        Pre-Qualification vendors
                      </span>
                    </Col>
                    <Col
                      xs={12}
                      md={8}
                      lg={8}
                      className="d-flex justify-content-end align-items-center pe-3"
                    >
                      <button
                        className="btnTable text-nowrap"
                        style={{ width: "auto", marginBottom: 0 }}
                        onClick={inviteSupplier}
                        title="Invite Supplier for Pre-Qualification"
                      >
                        <i className="bi bi-cursor"></i> Invite Supplier
                      </button>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={pqList?.data || []}
                          progressPending={pqList?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={pqPagination.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <ShowStatus
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />
    </main>
  );
};

export default PQVendorList;
